import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { permissionsSelector } from '@applyboard/ab-common';
export var userPermissionsProps = createStructuredSelector({
  userPermissions: permissionsSelector
});
var userPermissionsEnhancer = connect(userPermissionsProps);
export default userPermissionsEnhancer;